
import { AUTH_API_URL,Client_API_URL } from "../config";
 
const login = async (userEmail, userPassword, clientName) => {
  try {
    const data = {
      userEmail: userEmail,
      userPassword: userPassword,
      clientName: clientName,
    };
 
    const response = await fetch(`${Client_API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
 
    const responseData = await response.json();
 
    if (response.status === 200) {
      return { success: true, data: responseData };
    } else {
      return {
        success: false,
        error: responseData.message || "An error occurred during login",
        status: response.status,
      };
    }
  } catch (error) {
    return { success: false, error: "An error occurred during login" };
  }
};
 
export { login };
 
 
 